module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.7-136.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.7.md
// module id = 553
// module chunks = 239